import React from "react";

const ModalClose = () => (
  <svg data-name="Component 76" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path data-name="Rectangle 4588" style={{ fill: "none" }} d="M0 0h24v24H0z" />
    <path
      data-name="Path 11159"
      d="m563 26.71-1.21-1.21-4.79 4.79-4.79-4.79-1.21 1.21 4.79 4.79-4.79 4.79 1.21 1.21 4.79-4.79 4.79 4.79 1.21-1.21-4.79-4.79z"
      transform="translate(-545 -19.5)"
      style={{ fill: "#555" }}
    />
  </svg>
);

export default ModalClose;
